"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _css = require("@emotion/css");
var _react = require("react");
var _useStylesUtils = require("../../hooks/useStylesUtils");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = (props, avatarUrl) => {
  const {
    fontFamily,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    size = 'medium',
    background = themeColors?.primary.light
  } = props;
  const {
    fontSizeProps,
    getElementHeight
  } = (0, _useStylesUtils.useStylesUtils)();
  const ccAvatarStyle = (0, _react.useMemo)(() => {
    const sizeProps = () => {
      const height = getElementHeight(size);
      const width = height;
      return {
        height,
        width
      };
    };
    const ccAvatar = (0, _css.css)({
      fontFamily: fontFamily,
      color: themeColors?.primary.main,
      background: background,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      flex: 'none',
      borderRadius: '50%',
      overflow: 'hidden',
      position: 'relative',
      ...fontSizeProps(size),
      ...sizeProps()
    });
    const ccAvatarImage = (0, _css.css)({
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundImage: `url('${avatarUrl}')`
    });
    return {
      ccAvatar,
      ccAvatarImage
    };
  }, [avatarUrl, fontFamily, fontSizeProps, getElementHeight, background, size, themeColors?.primary.main]);
  return {
    'cc-Avatar': ccAvatarStyle.ccAvatar,
    'cc-Avatar__image': ccAvatarStyle.ccAvatarImage
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;